<template>
   <div class="pt-16 w-screen h-auto bg-slate-700 text-slate-200">
       <h1>Images</h1>
       <ul class="flex flex-wrap">
            <li v-for="i in images" class="w-1/2 flex flex-wrap border border-white/10 my-1 px-1" :key="i.id">
                <div class="w-1/3 p-4">
                        <img :src="buildPath(i)" />
                        <a :name="i.id">{{ i.id }}</a>
                        <span class="text-xs">{{ i.filename }}</span>
                </div>

                <ul class="w-2/3">
                    <li>t:<input v-model="i.title" class="w-full text-sm p-1 bg-slate-800 text-slate-200 mb-1"></li>
                    <li>c:<input v-model="i.caption" class="w-full text-xs p-1 bg-slate-800 text-slate-200 mb-1"/></li>
                    <li>d:<input type="text" v-model="i.description" class="w-full text-xs p-1 bg-slate-800 text-slate-200 mb-1"/></li>
                    <li><button @click="saveImageMeta(i)">save</button></li>
                </ul>

            </li>
       </ul>
   </div>
</template>

<script>
import TextInput from '@/components/TextInput.vue'
import { Link } from '@inertiajs/vue3'
import { api } from '@/api';

export default {
   name: "ImageEditor",
   components: { Link, TextInput },
   props: ['images'],
//    watch: {
//         '$page.hash'(newUrl, oldUrl) {
//             console.log(newUrl)
//         }
//    },
   computed: {},
   data() {
       return {
            size: '320x120'
       }
   },
   mounted() {

   },
   methods: {
        buildPath(i) {
            if(!i) return;
            return `/storage/webp/${i.filename}-${this.size}.webp`;
        },
        saveImageMeta(i) {
            api.post('save-image-meta', {image: i});
        }
   }
}
</script>
